import * as dataStore from './DataStore';
import Series from '../models/Series';
import { attachFunctionToCallback, getNovSchema } from "../utility";
import { performJsonpGetRequest } from "../lib/HttpRequest";

/**
 * @returns a Series object
 */
export function getSeries() {
	const series = dataStore.getJsonData().FeatureContent.SeriesInfo;
	if (series) {
		return new Series(series);
	}
}

const similarSeriesInfoResultCallbackName = 'similarSeriesInfoResultCallback';

export function fetchSimilarSeriesData(seriesUi, postAction) {
	const profileData = dataStore.getProfileData();
	const url = generateUrl(seriesUi, profileData);

	attachFunctionToCallback(postAction, similarSeriesInfoResultCallbackName);		
	performJsonpGetRequest(url, similarSeriesInfoResultCallbackName);
}

function generateUrl(seriesUi, profileData) {
	const apiEndpoint = `${getNovSchema()}${dataStore.getBaseUrl()}/Data/GetSeriesInfo?`;
	const customerInfo = `profile=${profileData.Profile}&password=${profileData.Password}&custLinks=${dataStore.getCustLinks()}`;
	const series = `&seriesUi=${seriesUi}`;
	const url = `${apiEndpoint}${customerInfo}${series}`;

	return encodeURI(url);
}


// WEBPACK FOOTER //
// ./src/data/SeriesSelectors.js